module.exports = __webpack_public_path__ + "img/map.31d1575c.png";